"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AccountWrap = exports.OperationNav = exports.BurgerWrap = exports.NavBtn = exports.NavWrapper = exports.LogoWrapper = exports.MegaMenuWrap = exports.headerHeight = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../../../Layout");

var _Button = _interopRequireDefault(require("../../../Button"));

var _mediaQueries = _interopRequireDefault(require("../../../../styles/mediaQueries"));

var headerHeight = '8rem';
exports.headerHeight = headerHeight;
var MegaMenuWrap = (0, _styled.default)(_Layout.Container)({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  minHeight: headerHeight,
  position: 'relative',
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
    height: headerHeight
  }
});
exports.MegaMenuWrap = MegaMenuWrap;
var LogoWrapper = (0, _styled.default)('div')(function (_ref) {
  var isNavOpen = _ref.isNavOpen;
  return {
    opacity: isNavOpen ? '0' : '1',
    transition: isNavOpen ? 'opacity .3s ease-in' : 'opacity 0s ease-out'
  };
});
exports.LogoWrapper = LogoWrapper;
var NavWrapper = (0, _styled.default)('div')(_defineProperty({
  display: 'none'
}, _mediaQueries.default.xlarge, {
  display: 'flex',
  flex: '1 1 auto',
  justifyContent: 'center'
}));
exports.NavWrapper = NavWrapper;
var NavBtn = (0, _styled.default)(_Button.default)(function (_ref3) {
  var space = _ref3.theme.space;
  return {
    margin: "0 ".concat(space.xsmall)
  };
});
exports.NavBtn = NavBtn;
var BurgerWrap = (0, _styled.default)('div')(function (_ref4) {
  var _ref5;

  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      globalNav = _ref4$theme.globalNav,
      space = _ref4$theme.space,
      isNavOpen = _ref4.isNavOpen;
  return _ref5 = {
    color: colors[globalNav.burgerColor],
    opacity: isNavOpen ? '0' : '1',
    transition: 'all .3s ease',
    borderLeft: "".concat(globalNav.borderBurgerWrap.width, " ").concat(globalNav.borderBurgerWrap.style, " ").concat(colors[globalNav.borderBurgerWrap.color]),
    borderRight: "".concat(globalNav.borderBurgerWrap.width, " ").concat(globalNav.borderBurgerWrap.style, " ").concat(colors[globalNav.borderBurgerWrap.color]),
    padding: "0 ".concat(space.large, " 0 ").concat(space.medium),
    minHeight: headerHeight,
    display: 'flex',
    alignItems: 'center'
  }, _defineProperty(_ref5, _mediaQueries.default.untilSmall, {
    padding: '0'
  }), _defineProperty(_ref5, '&:hover', {
    color: colors[globalNav.burgerColorHover]
  }), _ref5;
});
exports.BurgerWrap = BurgerWrap;
var OperationNav = (0, _styled.default)('div')({
  display: 'flex',
  alignItems: 'center',
  minHeight: headerHeight
});
exports.OperationNav = OperationNav;
var AccountWrap = (0, _styled.default)('div')(function (_ref6) {
  var _ref7;

  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      space = _ref6$theme.space,
      globalNav = _ref6$theme.globalNav,
      account = _ref6.account,
      onlyAccountPrimaryLinks = _ref6.onlyAccountPrimaryLinks;
  var borderLeft = account ? "".concat(globalNav.borderBurgerWrap.width, " ").concat(globalNav.borderBurgerWrap.style, " ").concat(colors[globalNav.borderBurgerWrap.color]) : '0';
  return _ref7 = {
    display: 'flex',
    alignItems: 'center',
    height: headerHeight,
    padding: "0 ".concat(space.xsmall),
    borderLeft: borderLeft
  }, _defineProperty(_ref7, _mediaQueries.default.small, {
    padding: "0 ".concat(space.large)
  }), _defineProperty(_ref7, _mediaQueries.default.untilMedium, {
    borderLeft: onlyAccountPrimaryLinks ? '0' : borderLeft
  }), _ref7;
});
exports.AccountWrap = AccountWrap;